import { Channel } from '../enums/channel';

export const getShareURL = (shortUrl: string) => {
    // const hostname = window.location.hostname.endsWith('waves.com') ? window.location.hostname : 'www.waves.com';
    return `https://www.waves.com/r/${ shortUrl }`;
};

export const parseReferUrl = () => {
    // https://dev.waves.com/r/yl6wb1tw
    if(window.location.pathname.indexOf('/r/') === -1) return null;

    const part = window.location.pathname.replace('/r/', '');
    const shortURL = (part.endsWith('fb') || part.endsWith('tw') || part.endsWith('em')) ? part.substring(0, part.length - 2) : part;

    const suffix = part.replace(shortURL, '');
    let channelName = 'purl';
    let channelID = Channel.purl;

    switch (suffix) {
        case 'fb': {
            channelName = 'facebook';
            channelID = Channel.facebook;
            break;
        }

        case 'tw': {
            channelName = 'twitter';
            channelID = Channel.twitter;
            break;
        }

        case 'em': {
            channelName = 'email';
            channelID = Channel.email;
            break;
        }
    }

    return {
        shortURL,
        channelName,
        channelID,
    };
};